/* Project B showroom environment only. Project A interactions live untouched
   in tcg-vault-hero.js. */
(function () {
  "use strict";

  function init(room) {
    if (!room || room.__tcgvEnvInit) return;
    room.__tcgvEnvInit = true;

    var dragging = false;
    var moved = false;
    var startX = 0;
    var startPan = 0;
    var dragPan = 0;
    var scrollPan = 0;
    var raf = null;
    var scrollRaf = null;
    var renderedPan = null;
    var roomRigReset = false;
    var revealed = false;
    var mobileStatic = false;
    var root = room.closest(".tcgv");
    var scrollRoot = room.closest(".tcgv-scroll") || root;
    var camera = room.closest(".tcgv__camera");
    var roomRig = room.querySelector(".tcgv-room-parts");
    var coarseMQ = window.matchMedia("(pointer: coarse)");
    var mobileViewMQ = window.matchMedia("(max-width: 820px)");

    function isMobileCameraMode() {
      return coarseMQ.matches || mobileViewMQ.matches;
    }

    function limit() {
      return Math.max(48, room.clientWidth * 0.09);
    }

    function render() {
      raf = null;
      var max = limit();
      var combined = Math.max(-max, Math.min(max, dragPan + scrollPan));
      if (roomRig && !roomRigReset) {
        roomRig.style.setProperty("--room-drag-x", "0px");
        roomRigReset = true;
      }
      if (camera && combined !== renderedPan) {
        camera.style.setProperty("--scene-pan-x", combined.toFixed(2) + "px");
        renderedPan = combined;
      }
      if (!revealed) {
        room.style.setProperty("--env-reveal", "1");
        revealed = true;
      }
    }

    function requestRender() {
      if (!raf) raf = requestAnimationFrame(render);
    }

    function setDragPan(next) {
      var max = limit();
      dragPan = Math.max(-max, Math.min(max, next));
      requestRender();
    }

    function syncScroll() {
      scrollRaf = null;
      if (!root || !scrollRoot) return;
      if (isMobileCameraMode()) {
        scrollPan = 0;
        if (!mobileStatic) {
          scrollRoot.classList.remove("is-tcgv-sticky", "is-tcgv-past");
          mobileStatic = true;
          requestRender();
        }
        return;
      }
      mobileStatic = false;
      var range = Math.max(1, scrollRoot.offsetHeight - window.innerHeight);
      var rect = scrollRoot.getBoundingClientRect();
      var top = rect.top;
      var sticky = top <= 0 && rect.bottom >= window.innerHeight;
      var past = rect.bottom < window.innerHeight;
      scrollRoot.classList.toggle("is-tcgv-sticky", sticky);
      scrollRoot.classList.toggle("is-tcgv-past", past);
      scrollPan = 0;
      requestRender();
    }

    function requestScrollSync() {
      if (isMobileCameraMode() && mobileStatic) return;
      if (!scrollRaf) scrollRaf = requestAnimationFrame(syncScroll);
    }

    function down(event) {
      if (isMobileCameraMode()) return;
      if (event.button !== 0) return;
      dragging = true;
      moved = false;
      startX = event.clientX;
      startPan = dragPan;
      room.classList.add("is-dragging");
      if (room.setPointerCapture) room.setPointerCapture(event.pointerId);
    }

    function move(event) {
      if (isMobileCameraMode()) return;
      if (!dragging) return;
      var delta = event.clientX - startX;
      if (Math.abs(delta) > 5) moved = true;
      setDragPan(startPan + delta * 0.56);
    }

    function up(event) {
      if (!dragging) return;
      dragging = false;
      room.classList.remove("is-dragging");
      if (room.releasePointerCapture && room.hasPointerCapture(event.pointerId)) {
        room.releasePointerCapture(event.pointerId);
      }
    }

    room.addEventListener("pointerdown", down);
    room.addEventListener("pointermove", move);
    room.addEventListener("pointerup", up);
    room.addEventListener("pointercancel", up);
    room.addEventListener("wheel", function (event) {
      if (isMobileCameraMode()) return;
      if (Math.abs(event.deltaX) <= Math.abs(event.deltaY)) return;
      setDragPan(dragPan - event.deltaX * 0.32);
      event.preventDefault();
    }, { passive: false });
    room.addEventListener("click", function (event) {
      if (!moved) return;
      event.preventDefault();
      event.stopPropagation();
      moved = false;
    }, true);
    window.addEventListener("scroll", requestScrollSync, { passive: true });
    window.addEventListener("resize", requestScrollSync, { passive: true });
    syncScroll();
  }

  function boot() {
    document.querySelectorAll("[data-tcgv-env-scroll]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
}());
